import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges } from "@angular/core";
import { MapService } from "@services/map.service";
import { IPolyline } from "@typings/google.maps.angular";
import { ICommonMapComponent, VMapComponent } from "../v-map/v-map/v-map.component";

@Component({
    selector: "ui-gmap-polylines",
    template: ""
})
export class UIGmapPolylinesComponent implements OnInit, OnChanges, OnDestroy {

    @Input() polylines: IPolyline[] = [];

    veriMap: ICommonMapComponent;

    polylineMap: { polyline: IPolyline, googlePolyline: google.maps.Polyline }[] = [];

    constructor(
        @Optional() private readonly vMap: VMapComponent,
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly mapService: MapService) {
    }

    ngOnInit() {
    }

    ngOnChanges(onChangesObj: SimpleChanges) {
        if (!this.veriMap) {
            this.veriMap = this.vMap || this.mapService.findVeriMap(this.elementRef);
        }

        this.veriMap.mapInitialisedPromise.then(map => {
            this.updatePolylines();
        });
    }

    ngOnDestroy() {
        this.polylineMap.forEach(map => {
            map.googlePolyline.setMap(null);
        });

        this.polylineMap = [];
    }

    // ---------------------

    private updatePolylines() {
        if (!this.veriMap) {
            return;
        }

        if (this.polylines) {
            this.createPolylines();
        }

        this.removePolylines();
    }

    private createPolylines() {
        const gMap = this.veriMap.getMap();

        this.polylines.forEach(p => {

            var options: google.maps.PolylineOptions = {
                path: p.path,
                geodesic: true,
                strokeColor: p.options.stroke.color,
                strokeOpacity: p.options.stroke.opacity,
                strokeWeight: p.options.stroke.weight
            };

            if (p.options.icons) {
                options.icons = p.options.icons;
            }

            // Check to see if we have a map already, if so update it
            var existingPolylineMap = this.polylineMap.find(map => map.polyline.id == p.id);

            if (existingPolylineMap) {
                existingPolylineMap.googlePolyline.setOptions(options);

                return;
            }

            var polyline = new google.maps.Polyline(options);

            if (p.options.events) {
                if (p.options.events.mouseover) {
                    polyline.addListener("mouseover", (args) => {
                        p.options.events.mouseover(polyline, "mouseover", null, [args]);
                    });
                }
            }

            polyline.setMap(gMap);

            this.polylineMap.push({ polyline: p, googlePolyline: polyline });
        });
    }

    private removePolylines() {

        // Need to do the reverse now, find objects in our map that dont exist in polylines
        this.polylineMap.forEach(map => {
            var found = this.polylines.some(p => p.id == map.polyline.id);

            if (!found) {
                map.googlePolyline.setMap(null);
                map.googlePolyline = null;
                map.polyline = null;
            }
        });

        this.polylineMap = this.polylineMap.filter(map => map.googlePolyline);
    }
}
